import { render } from "./SignIn.vue?vue&type=template&id=bea6b3c8"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=bea6b3c8&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__